module.exports = __webpack_public_path__ + "static/origens-projeto_r-046f791aef7f22a4f41f8253af9dec33.jpg";